import React, { ReactNode, useMemo } from 'react';
import {
    Anchor,
    Breadcrumbs as MantineBreadcrumbs,
    Text,
    Skeleton,
} from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import { IconChevronRight } from '@tabler/icons-react';

type Props = {
    isLoading?: boolean;
    friendlyLabels?: {
        originalLabel?: string;
        friendlyLabel?: string;
    }[];
};
export default function Breadcrumbs({ friendlyLabels, isLoading }: Props) {
    const { pathname } = useLocation();

    const paths = useMemo(() => {
        const pathNames = pathname.split('/').slice(1);

        if (friendlyLabels) {
            return pathNames.map(pathName => {
                const friendlyLabel = friendlyLabels.find(
                    label => label.originalLabel === pathName,
                );
                if (friendlyLabel) {
                    return friendlyLabel.friendlyLabel;
                }
                return pathName;
            });
        }

        return pathNames;
    }, [friendlyLabels, pathname]);

    const crumbs = useMemo(() => {
        const filteredCrumbs: ReactNode[] = [];
        const pathBuilder = '';
        paths.forEach((path, index) => {
            if (!path) {
                return;
            }

            filteredCrumbs.push(
                index === paths.length - 1 ? (
                    <Text
                        key={`${pathBuilder}`}
                        className="capitalize text-gray-400"
                    >
                        {path}
                    </Text>
                ) : (
                    <Anchor
                        key={`${pathBuilder}`}
                        component={Link}
                        to={`${pathBuilder}`}
                        className="capitalize"
                    >
                        {path}
                    </Anchor>
                ),
            );
        });

        return filteredCrumbs;
    }, [paths]);

    if (isLoading) {
        return <Skeleton height={24} width={300} radius="xl" />;
    }

    return (
        <MantineBreadcrumbs
            separator={<IconChevronRight color="lightGrey" />}
            color="lightGray"
            className="capitalize text-gray-400"
        >
            {crumbs}
        </MantineBreadcrumbs>
    );
}
